import { Disclosure } from '@headlessui/react'
import ChevronIcon from '../icons/ChevronIcon'
import classNames from 'classnames'

type PropTypes = {
  title?: string
  children: React.ReactNode
  defaultOpen?: boolean
  collapsedContent?: React.ReactNode
  panelClasses?: string
}

const BaseAccordion = ({ title, children, collapsedContent, defaultOpen = false, panelClasses = '' }: PropTypes) => {
  return (
    <div className="flex flex-col w-full">
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex items-center justify-between w-full px-3.5 py-5 hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-75">
              <div className="flex items-center justify-between w-full">
                <h1 className="text-sm leading-[16.8px] font-semibold">{ title }</h1>

                {!open && collapsedContent && (
                  <span className="text-xs mr-3 text-gray-900">{collapsedContent}</span>
                )}
              </div>

              <ChevronIcon className={classNames('h-3 w-3 text-black', {
                'transform -rotate-90': !open,
              })}
              />
            </Disclosure.Button>
            <Disclosure.Panel className={classNames(panelClasses, 'px-3.5 pb-5')}>
              { children }
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  )
}

export default BaseAccordion
